import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container } from '../../components/Layout';
import Button from '../../components/Button';
import { getSmallImage } from '../../utils/prismic';

const ListContainer = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
  flex-wrap: wrap;
  padding: var(--size-space-large);
  > li {
    padding: var(--size-space-medium);
    position: relative;
    overflow: hidden;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - var(--size-space-tiny) - var(--size-space-tiny));

    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    margin: var(--size-space-tiny);
    border: 0.4rem solid var(--color-primary-dark);
    background: var(--color-container);
  }
`;
const ListItem = styled.div`
  position: relative;
  overflow: hidden;
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: var(--color-primary-light);
  }
  button,
  .button {
    margin-top: var(--size-space-small);
  }
  img {
    display: inline-block;
    margin-top: 0;
  }
`;

const SliceBlockList = ({ input }) => {
  //console.log(input.items);

  const items = input.items.map(
    (
      {
        heading,
        rich_text,
        theme_module,
        button_label,
        button_link,
        thumbnail,
      },
      index
    ) => {
      const dataButton = button_label
        ? {
            label: button_label,
            ...button_link,
          }
        : null;

      return (
        <Container
          as="li"
          key={theme_module + index}
          content={rich_text.html}
          theme={theme_module && theme_module.toLowerCase()}
          isRichText
        >
          <ListItem key={index + 1}>
            <img
              src={getSmallImage(thumbnail).url}
              alt={getSmallImage(thumbnail).alt}
              width={getSmallImage(thumbnail).width / 2}
              height={getSmallImage(thumbnail).height / 2}
            />
            <div
              className="blockHeading"
              dangerouslySetInnerHTML={{ __html: heading.html }}
            />
            <div
              className="blockContent"
              dangerouslySetInnerHTML={{ __html: rich_text.html }}
            />
            {dataButton && <Button button={dataButton} />}
          </ListItem>
        </Container>
      );
    }
  );

  return (
    <Container
      color_dark={input.primary.theme_color_dark}
      color_light={input.primary.theme_color_light}
      spaceScale={
        input.primary.scale_module_spacing &&
        input.primary.scale_module_spacing.toLowerCase()
      }
      textScale={
        input.primary.scale_module_text &&
        input.primary.scale_module_text.toLowerCase()
      }
    >
      <ListContainer>{items}</ListContainer>
    </Container>
  );
};

export default SliceBlockList;

SliceBlockList.propTypes = {
  input: PropTypes.object.isRequired,
};
